import { render, staticRenderFns } from "./ImprimantesHpLatex630.vue?vue&type=template&id=4545ad1e&scoped=true"
import script from "./ImprimantesHpLatex630.vue?vue&type=script&lang=js"
export * from "./ImprimantesHpLatex630.vue?vue&type=script&lang=js"
import style0 from "./ImprimantesHpLatex630.vue?vue&type=style&index=0&id=4545ad1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4545ad1e",
  null
  
)

export default component.exports